import type { TImage } from "@/types/global";

export const clientSlideImages: TImage[] = [
  {
    src: "/static/logos/company.svg",
    alt: "company-logo",
  },
  {
    src: "/static/logos/bio-extratus.svg",
    alt: "bio-extratus-logo",
  },
  {
    src: "/static/logos/alura.svg",
    alt: "alura-logo",
  },
  {
    src: "/static/logos/cobrasis.svg",
    alt: "cobrasis-logo",
  },
  {
    src: "/static/logos/evolucre.svg",
    alt: "evolucre-logo",
  },
];
